












import { ApiGroupBuyingOrderGroupOrderInfoResponse } from '@/api'
import { defineClassComponent } from '@/hooks'

// @index('./content_*.vue', (f, _) => `import { default as GroupBuying${_.pascal(f.name)} } from '${f.path}${f.ext}'`)
import { default as GroupBuyingContentGoods } from './content_goods.vue'
import { default as GroupBuyingContentRule } from './content_rule.vue'
import { default as GroupBuyingContentStatus } from './content_status.vue'
// @endindex

export default defineClassComponent<{
  data: ApiGroupBuyingOrderGroupOrderInfoResponse
  noRule?: boolean
}>(
  {
    components: {
      // @index('./content_*.vue', (f, _) => `GroupBuying${_.pascal(f.name)},`)
      GroupBuyingContentGoods,
      GroupBuyingContentRule,
      GroupBuyingContentStatus,
      // @endindex
    },
    props: ['data', 'noRule'],
  },
  () => class {},
)
